import React from "react";
import {
  BackgroundFigure,
  BlockTitle,
  Courses,
  LecturesLibraryContainer
} from "./styles";
import {CourseItem} from "components/lecturesPage/CourseItem";
import { CourseInfo } from "models/lectures/EntityModels/lectures";

export const LecturesLibrary = ({ courses }) => {
  return (
    <LecturesLibraryContainer>
      <BlockTitle>БИБЛИОТЕКА ЛЕКТОРИЯ</BlockTitle>
      <Courses>
        {courses?.map((course: CourseInfo) => (
          <CourseItem
            key={course.id}
            id={course.id}
            title={`${course.name} / ${course.year}`}
            description={`${course.videoCount} видео`}
            srcImage={course.preview}
          />
        ))}
      </Courses>
      <BackgroundFigure src={'svgs/lectureLibraryRectangle.svg'} />
    </LecturesLibraryContainer>
  );
}
